import React from 'react';
import { Form } from 'react-bootstrap';
import { useLanguage } from '../../../../../../API/Context/LanguageContext';
import { FiX } from 'react-icons/fi';

export interface EnumOption {
  id: number | string;
  labels: Record<number, string>;
}

interface EnumSelectProps {
  value: number | string | null | undefined;
  onChange: (val: any) => void;
  options: EnumOption[];
  placeholder?: string;
  isInvalid?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  className?: string;
  clearable?: boolean;
  required?: boolean; // 👈 Add required prop
}

const EnumSelect: React.FC<EnumSelectProps> = ({
  value,
  onChange,
  options,
  placeholder,
  isInvalid = false,
  disabled = false,
  size,
  className = '',
  clearable = false,
  required = false, // 👈 Default to false
}) => {
  const { lan } = useLanguage();

  const defaultPlaceholder = (lan as number) === 0 ? 'Seleccionar...' : 'Select...';

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const rawVal = e.target.value;
    const selectedOption = options.find((opt) => String(opt.id) === rawVal);

    if (selectedOption) {
      onChange(selectedOption.id);
    } else {
      onChange(rawVal === '' ? null : rawVal);
    }
  };

  const handleClear = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(null);
  };

  const currentLanKey = (lan as number) === 0 ? 0 : 1;
  const isSelected = value !== null && value !== undefined && value !== '';
  const showClear = clearable && isSelected && !disabled && !required;

  return (
    <div className="position-relative w-100 d-inline-flex align-items-center">
      <Form.Select
        {...(size ? { size } : {})}
        value={value ?? ''}
        isInvalid={isInvalid}
        disabled={disabled}
        className={`${className} ${showClear ? 'pe-4' : ''}`}
        onChange={handleChange}
        style={
          showClear
            ? {
                backgroundImage: 'none',
                appearance: 'none',
                WebkitAppearance: 'none',
                MozAppearance: 'none',
              }
            : undefined
        }
      >
        {/* Render placeholder ONLY if field is not required */}
        {!required && (
          <option value="" disabled hidden>
            {placeholder || defaultPlaceholder}
          </option>
        )}

        {options.map((item) => (
          <option key={item.id} value={item.id}>
            {item.labels[currentLanKey] || item.labels[0] || 'Label Error'}
          </option>
        ))}
      </Form.Select>

      {showClear && (
        <button
          type="button"
          onClick={handleClear}
          className="position-absolute end-0 me-2 btn btn-link p-0 text-muted border-0 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 5,
            width: '18px',
            height: '18px',
            cursor: 'pointer',
            lineHeight: 1,
          }}
          title={currentLanKey === 0 ? 'Limpiar selección' : 'Clear selection'}
        >
          <FiX size={14} />
        </button>
      )}
    </div>
  );
};

export default EnumSelect;
